<template>
  <div v-if='show' class='dialog_box ewm_box'>
    <div class='dialog text_center pos_r'>
      <div class='s_logo img_box hide'>
        <img src='@/assets/icons/ipad_logo.png' alt='logo'>
      </div>
      <div class='icon_close_btn iconic_close iconfont' @click='close'></div>
      <div class='line hide'></div>
      <img class='bg' src='@/assets/icons/ill_star@2x.png' width='100%' alt=''>
      <img class='bg2 hide' src='@/assets/icons/navbar_bg.png' width='100%' alt=''>
      <h3>HighFive Class App</h3>
      <div class='addit'>
        <span class='iconic_android iconfont dis_ib ver_m'></span>
        <i class='iconfont icon- dis_ib ver_m'></i>
        <span class='iconic_ios iconfont dis_ib ver_m'></span>
      </div>
      <div class='img_box'>
        <img src='@/assets/img/Highfive APP.png' width='180' height='180' alt=''>
      </div>
      <p v-if='device == "mobile"' v-html='$t("reading.highfiveClass.download.qrcodeMobile")'></p>
      <p v-else>{{ $t('reading.highfiveClass.download.qrcode') }}</p>
    </div>
  </div>
</template>

<script>
import { mediaDevice } from 'utils'

export default {
  props: ['show'],
  data () {
    return {
      device: '',

    }
  },
  methods: {
    init () {
      this.device = mediaDevice()
    },
    close () {
      this.$emit('close')
    },
  },
  beforeMount () {
    this.init()
  },
}
</script>
